module.exports = __webpack_public_path__ + "img/unclaimable.a826467c.png";